import { render, staticRenderFns } from "./ContactProfile.vue?vue&type=template&id=69fc703a&"
import script from "./ContactProfile.vue?vue&type=script&lang=js&"
export * from "./ContactProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports